// extracted by mini-css-extract-plugin
export default {"wrapper":"alternativeSpanish_wrapper__akrIG","button":"alternativeSpanish_button__QDcqa"};